<template>
  <div>
    <div class="timeline-tiles non-selectable">
      <component
        :is="type.details.tile"
        v-for="(type, key) in tiles"
        :key="'type-' + key"
        :selected="localSelectedPartialTypes.includes(key)"
        :type="type.details"
        :entries="type.entries"
        :tooltip="type.tooltip"
        @click.exact="toggleType(key, hasSelectedAllTiles ? 'single' : 'toggle', 1000)"
        @click.alt.exact="toggleType(key, 'single', 250)"
        @click.shift.exact="toggleType([], 'group', 250)"
      />
    </div>
    <div v-if="!hasSelectedAllTiles" class="q-pt-md">
      <q-btn
        label="Select All Tiles"
        size="12px"
        color="blue"
        @click="toggleType([], 'group', 0)"
      />
    </div>
    <div v-if="!$q.platform.has.touch" class="q-mt-sm text-grey-6 text-caption">
      <tip name="timelineShortcutKeys">
        <q-item-label>
          Holding down the <b>{{ $q.platform.is.mac ? 'OPTION key' : 'ALT key' }}</b> and clicking on a tile will unselect all the other tiles.
        </q-item-label>
        <q-item-label>
          Holding down the <b>SHIFT key</b> and clicking on a tile will select all the tiles.
        </q-item-label>
      </tip>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    tiles: {
      type: Object,
      required: true
    },
    selectedPartialTypes: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  emits: ['update:selectedPartialTypes'],
  data () {
    return {
      localSelectedPartialTypes: JSON.parse(JSON.stringify(this.selectedPartialTypes)),
      selectionTimer: null
    }
  },
  computed: {
    hasSelectedAllTiles () {
      return Object.keys(this.tiles).length === this.localSelectedPartialTypes.length
    }
  },
  watch: {
    'selectedPartialTypes' (val) {
      this.localSelectedPartialTypes = JSON.parse(JSON.stringify(val))
    }
  },
  methods: {
    // Toggle tiles based on mode
    toggleType (val, mode = 'toggle', timeout = 750) {
      clearTimeout(this.selectionTimer)

      switch (mode) {
        // toggle a single tile
        case 'toggle':
          if (this.localSelectedPartialTypes.includes(val)) {
            this.localSelectedPartialTypes.splice(this.localSelectedPartialTypes.indexOf(val), 1)
          }
          else {
            this.localSelectedPartialTypes.push(val)
          }
          break
        // Select a single tile out of the entire group
        case 'single':
          this.localSelectedPartialTypes = [val]
          break
        // Mass select all of the options
        case 'group':
          this.localSelectedPartialTypes = Object.keys(this.tiles)
          break
      }

      // Debounce updating the main model value
      this.selectionTimer = setTimeout(() => {
        this.$emit('update:selectedPartialTypes', JSON.parse(JSON.stringify(this.localSelectedPartialTypes)))
      }, timeout)
    }
  }
}
</script>
